module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-i18next/~/html-parse-stringify2/index.js
// module id = 1005
// module chunks = 0